import { type FC } from 'react'

export const SelectAccountSkeletonPage: FC = () => null
